import { Card, Select, Space, Spin } from 'antd';
import Title from 'antd/es/typography/Title';
import useTenantSelector from 'hooks/useTenantSelector';

/**
 * Shell reutilizable para páginas del perfil liftlogic v2.
 *
 * Propósito: unificar el layout (card + header + tenant selector + toolbar)
 * de cada página de administración para que agregar una nueva solo implique
 * escribir el contenido específico.
 *
 * Props:
 *  - title: string
 *  - showTenantSelector: boolean — si true, muestra el dropdown y el render
 *      prop `children` recibe `{ selectedTenantId }`. Si no hay tenant
 *      seleccionado, muestra un mensaje placeholder.
 *  - toolbar: ReactNode — botones a la derecha del header
 *  - children: ReactNode | ({ selectedTenantId }) => ReactNode
 */
const LiftlogicResourcePage = ({
  title,
  showTenantSelector = false,
  toolbar,
  children,
}) => {
  const { tenants, selectedTenantId, setSelectedTenantId, loading } =
    useTenantSelector();

  const renderBody = () => {
    if (!showTenantSelector) {
      return typeof children === 'function' ? children({}) : children;
    }
    if (loading) return <Spin />;
    if (!selectedTenantId) {
      return <div>Seleccione un tenant para continuar.</div>;
    }
    return typeof children === 'function'
      ? children({ selectedTenantId })
      : children;
  };

  return (
    <Space direction="vertical" className="w-full">
      <Card>
        <div className="flex flex-row justify-between items-center flex-wrap gap-2">
          <Title level={3} style={{ margin: 0 }}>
            {title}
          </Title>
          <Space>
            {showTenantSelector && (
              <Select
                placeholder="Seleccionar tenant"
                style={{ minWidth: 260 }}
                value={selectedTenantId ?? undefined}
                onChange={setSelectedTenantId}
                loading={loading}
                options={tenants.map((t) => ({
                  value: t.id,
                  label: `${t.id} — ${t.organization}`,
                }))}
              />
            )}
            {toolbar}
          </Space>
        </div>
      </Card>
      <Card>{renderBody()}</Card>
    </Space>
  );
};

export default LiftlogicResourcePage;
